import { useTranslation } from "react-i18next";
import { cn } from "../../../../utils/classnames";
import { createTypographyHelper } from "../../../../utils/typography";
import JourneyIcon from "../../../../images/services/journey.svg";
import ChatIcon from "../../../../images/services/chat.svg";
import ClockIcon from "../../../../images/services/clock.svg";
import PrivacyIcon from "../../../../images/services/privacy.svg";
import ProfessionalismIcon from "../../../../images/services/professionalism.svg";
import TravelIcon from "../../../../images/services/travel.svg";

const TailoredToYouImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-services/airport-transfer-tailored-to-you.png";
const TimeWellSpentImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-services/airport-transfer-time-well-spent.png";
const FluentRespectfulCulturallyAwareImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-services/airport-transfer-fluent-respectful-culturally-aware.png";
const PrivacyYouCanTrustImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-services/airport-transfer-privacy-you-can-trust.png";
const ProfessionalismAtEveryTurnImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-services/airport-transfer-professionalism-at-every-turn.png";
const TravelWithConfidenceImage = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-services/airport-transfer-travel-with-confidence.png";

export const WhyChooseTaxiSection = () => {
  const { t, i18n } = useTranslation();
  const getTypographyClass = createTypographyHelper(i18n.language);

  return (
    <div className="tw:bg-[#F9F9F9] tw:py-12">
      <div className="tw:px-5 tw:lg:px-[82px]">
        <div className="tw:text-[#282828] tw:text-[22px] tw:leading-[26px] tw:font-libre-caslon-display tw:text-center tw:space-y-[10px]">
          <div>{t("Service.WhyChooseUsOverTaxi.Title")}</div>
          <div
            className={cn(
              "tw:text-[#8D8D8D]",
              getTypographyClass(14)
            )}
          >
            {t("Service.WhyChooseUsOverTaxi.Description")}
          </div>
        </div>
        <div className="tw:mt-[30px] tw:font-hanken-grotesk tw:grid tw:grid-cols-1 tw:lg:grid-cols-3 tw:gap-4">
          <div className="tw:bg-white tw:rounded-[10px] tw:border tw:border-[#F1F1F1] tw:overflow-hidden">
            <img
              src={TailoredToYouImage}
              className="tw:h-[200px] tw:w-full tw:object-cover tw:object-[center_-50px]"
              alt="Tailored to you"
            />
            <div className="tw:py-6 tw:border-b tw:border-b-[#F1F1F1]">
              <div className="tw:flex tw:items-center tw:gap-x-3 tw:px-8">
                <img src={JourneyIcon} alt="Journey" />
                <div
                  className={cn(
                    "tw:text-[#282828] tw:font-bold",
                    getTypographyClass(14)
                  )}
                >
                  {t("Service.WhyChooseUsOverTaxi.Card1.Title")}
                </div>
              </div>
            </div>
            <div
              className={cn(
                "tw:mt-6 tw:text-[#4E4E4E] tw:px-8 tw:pb-8",
                getTypographyClass(13)
              )}
            >
              {t("Service.WhyChooseUsOverTaxi.Card1.Description")}
            </div>
          </div>
          <div className="tw:bg-white tw:rounded-[10px] tw:border tw:border-[#F1F1F1] tw:overflow-hidden">
            <img
              src={TimeWellSpentImage}
              className="tw:h-[200px] tw:w-full tw:object-cover tw:object-[center_-45px]"
              alt="Time Well Spent"
            />
            <div className="tw:py-6 tw:border-b tw:border-b-[#F1F1F1]">
              <div className="tw:flex tw:items-center tw:gap-x-3 tw:px-8">
                <img src={ClockIcon} alt="Clock" />
                <div
                  className={cn(
                    "tw:text-[#282828] tw:font-bold",
                    getTypographyClass(14)
                  )}
                >
                  {t("Service.WhyChooseUsOverTaxi.Card2.Title")}
                </div>
              </div>
            </div>
            <div
              className={cn(
                "tw:mt-6 tw:text-[#4E4E4E] tw:px-8 tw:pb-8",
                getTypographyClass(13)
              )}
            >
              {t("Service.WhyChooseUsOverTaxi.Card2.Description")}
            </div>
          </div>
          <div className="tw:bg-white tw:rounded-[10px] tw:border tw:border-[#F1F1F1] tw:overflow-hidden">
            <img
              src={TravelWithConfidenceImage}
              className="tw:h-[200px] tw:w-full tw:object-cover tw:object-center"
              alt="Travel with Confidence"
            />
            <div className="tw:py-6 tw:border-b tw:border-b-[#F1F1F1]">
              <div className="tw:flex tw:items-center tw:gap-x-3 tw:px-8">
                <img src={TravelIcon} alt="Travel" />
                <div
                  className={cn(
                    "tw:text-[#282828] tw:font-bold",
                    getTypographyClass(14)
                  )}
                >
                  {t("Service.WhyChooseUsOverTaxi.Card3.Title")}
                </div>
              </div>
            </div>
            <div
              className={cn(
                "tw:mt-6 tw:text-[#4E4E4E] tw:px-8 tw:pb-8",
                getTypographyClass(13)
              )}
            >
              {t("Service.WhyChooseUsOverTaxi.Card3.Description")}
            </div>
          </div>
          <div className="tw:bg-white tw:rounded-[10px] tw:border tw:border-[#F1F1F1] tw:overflow-hidden">
            <img
              src={PrivacyYouCanTrustImage}
              className="tw:h-[200px] tw:w-full tw:object-cover tw:object-center"
              alt="Privacy You Can Trust"
            />
            <div className="tw:py-6 tw:border-b tw:border-b-[#F1F1F1]">
              <div className="tw:flex tw:items-center tw:gap-x-3 tw:px-8">
                <img src={PrivacyIcon} alt="Privacy" />
                <div
                  className={cn(
                    "tw:text-[#282828] tw:font-bold",
                    getTypographyClass(14)
                  )}
                >
                  {t("Service.WhyChooseUsOverTaxi.Card4.Title")}
                </div>
              </div>
            </div>
            <div
              className={cn(
                "tw:mt-6 tw:text-[#4E4E4E] tw:px-8 tw:pb-8",
                getTypographyClass(13)
              )}
            >
              {t("Service.WhyChooseUsOverTaxi.Card4.Description")}
            </div>
          </div>

          <div className="tw:bg-white tw:rounded-[10px] tw:border tw:border-[#F1F1F1] tw:overflow-hidden">
            <img
              src={FluentRespectfulCulturallyAwareImage}
              className="tw:h-[200px] tw:w-full tw:object-cover tw:object-center"
              alt="Fluent, Respectful, Culturally Aware"
            />
            <div className="tw:py-6 tw:border-b tw:border-b-[#F1F1F1]">
              <div className="tw:flex tw:items-center tw:gap-x-3 tw:px-8">
                <img
                  src={ChatIcon}
                  alt="Fluent, Respectful, Culturally Aware"
                />
                <div
                  className={cn(
                    "tw:text-[#282828] tw:font-bold",
                    getTypographyClass(14)
                  )}
                >
                  {t("Service.WhyChooseUsOverTaxi.Card5.Title")}
                </div>
              </div>
            </div>
            <div
              className={cn(
                "tw:mt-6 tw:text-[#4E4E4E] tw:px-8 tw:pb-8",
                getTypographyClass(13)
              )}
            >
              {t("Service.WhyChooseUsOverTaxi.Card5.Description")}
            </div>
          </div>

          <div className="tw:bg-white tw:rounded-[10px] tw:border tw:border-[#F1F1F1] tw:overflow-hidden">
            <img
              src={ProfessionalismAtEveryTurnImage}
              className="tw:h-[200px] tw:w-full tw:object-cover tw:object-center"
              alt="Professionalism at Every Turn"
            />
            <div className="tw:py-6 tw:border-b tw:border-b-[#F1F1F1]">
              <div className="tw:flex tw:items-center tw:gap-x-3 tw:px-8">
                <img
                  src={ProfessionalismIcon}
                  alt="Fluent, Respectful, Culturally Aware"
                />
                <div
                  className={cn(
                    "tw:text-[#282828] tw:font-bold",
                    getTypographyClass(14)
                  )}
                >
                  {t("Service.WhyChooseUsOverTaxi.Card6.Title")}
                </div>
              </div>
            </div>
            <div
              className={cn(
                "tw:mt-6 tw:text-[#4E4E4E] tw:px-8 tw:pb-8",
                getTypographyClass(13)
              )}
            >
              {t("Service.WhyChooseUsOverTaxi.Card6.Description")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
